module.exports = __webpack_public_path__ + "static/media/headphones.bb0b8bdf.svg";